class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.onBodyClickEvent = this.onBodyClick.bind(this);
  }

  connectedCallback() {
    if (this._searchModalBound) return;
    this._searchModalBound = true;

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.isInlineSearch = this.classList.contains('header__search--inline');
    this.searchInput = this.querySelector('input[type="search"]');
    this.closeButton = this.querySelector('.search-modal__close-button, button.modal__close-button');

    if (!this.detailsContainer) return;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    if (this.isInlineSearch && this.searchInput) {
      this.searchInput.addEventListener('focus', this.onInlineFocus.bind(this));
      this.searchInput.addEventListener('input', this.onInlineFocus.bind(this));
      this.searchInput.addEventListener('click', this.onInlineFocus.bind(this));

      this.inlineBar = this.querySelector('.header-search-inline');
      if (this.inlineBar) {
        this.inlineBar.addEventListener('click', this.onInlineBarClick.bind(this));
      }
    }
  }

  isMobileInlineSearch() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  onInlineBarClick(event) {
    if (!this.isInlineSearch || !this.isMobileInlineSearch()) return;
    if (event.target.closest('.header-search-inline__reset')) return;

    event.stopPropagation();
    if (!this.isOpen()) {
      this.open({ target: this.searchInput });
    }
    this.searchInput?.focus();
  }

  isOpen() {
    return this.detailsContainer?.hasAttribute('open');
  }

  onInlineFocus(event) {
    if (event) event.stopPropagation();
    if (!this.isOpen()) {
      this.open({ target: this.searchInput });
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.isInlineSearch) return;
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer) return;

    // Input sits outside <details> in header mode — never use closest('details') alone
    const detailsEl =
      (event?.target?.closest?.('details') && this.contains(event.target.closest('details'))
        ? event.target.closest('details')
        : null) || this.detailsContainer;

    detailsEl.setAttribute('open', '');
    this.classList.add('is-search-open');
    document.body.classList.add('overflow-hidden', 'search_active');

    // Ignore the same click that opened the panel
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);

    if (!this.isInlineSearch) {
      const focusTarget = this.detailsContainer.querySelector('input:not([type="hidden"])');
      const trapContainer =
        this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer;
      trapFocus(trapContainer, focusTarget);
    }
  }
  close(focusToggle = true) {
    if (!this.detailsContainer) return;

    if (!this.isInlineSearch) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    } else if (focusToggle && this.searchInput && document.activeElement === this.searchInput) {
      this.searchInput.blur();
    }

    this.detailsContainer.removeAttribute('open');
    this.classList.remove('is-search-open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'search_active');
  }
}
customElements.define('details-modal', DetailsModal);